'use client'

// lib files
import { usePersonalizedResourceFetch } from '@/lib/hooks/usePersonalizedResource';
import { myListViewingHistory } from '@/lib/resources/my-list-viewing-history';

function NetworkMyListViewingHistory() {
  usePersonalizedResourceFetch(myListViewingHistory)

  return (<></>)
}

export default NetworkMyListViewingHistory
